var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:['topIcon', _vm.topIcon ? 'show' : ''],on:{"click":_vm.goTop}},[_c('img',{staticClass:"topImg",attrs:{"src":require("./assets/topimg.svg"),"alt":""}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }